/* ==========================================================================
   VITAL VIAL - Predictive search
   Rotating placeholder, intent shortcuts, debounced fetch, keyboard nav.
   Falls back to a normal /search submit when JS or the API is unavailable.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-vv-search]');
  if (!root) return;

  var input = root.querySelector('[data-vv-search-input]');
  var form = root.querySelector('[data-vv-search-form]');
  var resultsEl = root.querySelector('[data-vv-search-results]');
  var intentsEl = root.querySelector('[data-vv-search-intents]');
  var statusEl = root.querySelector('[data-vv-search-status]');
  var placeholder = root.querySelector('[data-vv-search-placeholder]');
  var rotator = root.querySelector('[data-vv-search-rotator]');
  var emptyTpl = root.querySelector('[data-vv-search-empty-template]');

  var TYPES = root.dataset.types || 'product,collection,article,page,query';
  var LIMIT = parseInt(root.dataset.limit, 10) || 5;
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var opener = null, releaseFocus = null;
  var controller = null, debounceId = null, rotateId = null;
  var lastQuery = '';

  /* ---------- Open / close ---------------------------------------------- */
  function open() {
    opener = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vv-no-scroll');
    startRotation();
    setTimeout(function () { input && input.focus(); }, 120);
    document.querySelectorAll('[data-vv-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vv-no-scroll');
    stopRotation();
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
    document.querySelectorAll('[data-vv-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (opener && opener.focus) opener.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vv-search-open]')) { e.preventDefault(); open(); }
    else if (e.target.closest('[data-vv-search-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    // Cmd/Ctrl+K opens search
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      root.classList.contains('is-open') ? close() : open();
    }
  });

  /* ---------- Rotating placeholder -------------------------------------- */
  var keywords = [];
  var kwScript = root.querySelector('[data-vv-search-keywords]');
  if (kwScript) {
    try { keywords = JSON.parse(kwScript.textContent) || []; } catch (e) { keywords = []; }
  }

  function startRotation() {
    if (!rotator || !keywords.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      rotator.textContent = keywords[0];
      return;
    }
    var i = 0;
    var speed = parseInt(root.dataset.rotateSpeed, 10) || 2800;
    var render = function () {
      rotator.innerHTML = '';
      var span = document.createElement('span');
      span.className = 'vv-search__placeholder-word';
      span.textContent = keywords[i];
      rotator.appendChild(span);
      i = (i + 1) % keywords.length;
    };
    render();
    stopRotation();
    rotateId = setInterval(render, speed);
  }
  function stopRotation() { if (rotateId) { clearInterval(rotateId); rotateId = null; } }

  function syncPlaceholder() {
    if (!placeholder) return;
    var has = input.value.length > 0;
    placeholder.classList.toggle('is-hidden', has);
    if (has) stopRotation(); else startRotation();
  }

  /* ---------- Fetch + render -------------------------------------------- */
  function search(q) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url = ROOT_URL + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=' + TYPES +
      '&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

    resultsEl.hidden = false;
    resultsEl.innerHTML = '<div class="vv-search__loading"><span></span><span></span><span></span></div>';
    if (intentsEl) intentsEl.hidden = true;

    fetch(url, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('search failed');
        return r.json();
      })
      .then(function (data) { render(data.resources.results, q); })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // Network/API failure: let the visitor submit the real search page
        resultsEl.innerHTML =
          '<div class="vv-search__empty"><p class="vv-body">Search is unavailable right now. ' +
          '<a class="vv-link" href="' + ROOT_URL + 'search?q=' + encodeURIComponent(q) + '">Open the full search page</a></p></div>';
      });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD'
      }).format(cents / 100);
    } catch (e) { return ''; }
  }

  function cardHTML(item, kind) {
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url :
              (item.image ? item.image : null);
    var meta = '';
    if (kind === 'product') meta = item.price != null ? money(item.price) : (item.vendor || '');
    else if (kind === 'article') meta = item.published_at ? new Date(item.published_at).toLocaleDateString() : '';
    else if (kind === 'collection') meta = 'Collection';
    else meta = 'Page';

    return '<a class="vv-search__result" href="' + esc(item.url) + '" data-vv-result>' +
      (img ? '<span class="vv-search__result-media"><img src="' + esc(img) +
             '" alt="" loading="lazy" decoding="async" width="56" height="56"></span>' : '') +
      '<span><span class="vv-search__result-title">' + esc(item.title) + '</span>' +
      (meta ? '<span class="vv-search__result-meta">' + esc(meta) + '</span>' : '') +
      '</span></a>';
  }

  function group(title, inner) {
    return '<section><p class="vv-search__group-title">' + esc(title) + '</p>' + inner + '</section>';
  }

  function render(res, q) {
    var html = '';
    var total = 0;

    if (res.queries && res.queries.length) {
      total += res.queries.length;
      html += group('Suggestions', '<div class="vv-search__terms">' + res.queries.map(function (t) {
        return '<a class="vv-search__term" href="' + esc(t.url) + '" data-vv-result>' +
          '<svg class="vv-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
          (t.styled_text || esc(t.text)) + '</a>';
      }).join('') + '</div>');
    }

    if (res.products && res.products.length) {
      total += res.products.length;
      html += group('Products', '<div class="vv-search__grid">' +
        res.products.map(function (p) { return cardHTML(p, 'product'); }).join('') + '</div>');
    }

    if (res.collections && res.collections.length) {
      total += res.collections.length;
      html += group('Collections', '<div class="vv-search__grid">' +
        res.collections.map(function (c) { return cardHTML(c, 'collection'); }).join('') + '</div>');
    }

    if (res.articles && res.articles.length) {
      total += res.articles.length;
      html += group('Journal', '<div class="vv-search__grid">' +
        res.articles.map(function (a) { return cardHTML(a, 'article'); }).join('') + '</div>');
    }

    if (res.pages && res.pages.length) {
      total += res.pages.length;
      html += group('Pages', '<div class="vv-search__grid">' +
        res.pages.map(function (p) { return cardHTML(p, 'page'); }).join('') + '</div>');
    }

    if (!total) {
      html = emptyTpl ? emptyTpl.innerHTML : '<div class="vv-search__empty"><p class="vv-body">No results.</p></div>';
    } else {
      html += '<div class="vv-search__all"><a class="vv-btn vv-btn--ghost" href="' + ROOT_URL +
        'search?q=' + encodeURIComponent(q) + '">View all results for &ldquo;' + esc(q) + '&rdquo;</a></div>';
    }

    resultsEl.innerHTML = html;
    if (statusEl) statusEl.textContent = total ? total + ' results for ' + q : 'No results for ' + q;
  }

  function reset() {
    resultsEl.hidden = true;
    resultsEl.innerHTML = '';
    if (intentsEl) intentsEl.hidden = false;
    if (statusEl) statusEl.textContent = '';
  }

  /* ---------- Input wiring ---------------------------------------------- */
  if (input) {
    input.addEventListener('input', function () {
      syncPlaceholder();
      var q = input.value.trim();
      clearTimeout(debounceId);
      if (q.length < 2) { reset(); lastQuery = ''; return; }
      if (q === lastQuery) return;
      debounceId = setTimeout(function () { lastQuery = q; search(q); }, 220);
    });

    // Arrow-key navigation through results
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = resultsEl.querySelectorAll('[data-vv-result]');
      if (!items.length) return;
      e.preventDefault();
      var idx = Array.prototype.indexOf.call(items, resultsEl.querySelector('.is-active'));
      items.forEach(function (i) { i.classList.remove('is-active'); });
      idx = e.key === 'ArrowDown' ? (idx + 1) % items.length : (idx <= 0 ? items.length - 1 : idx - 1);
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest' });
    });

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var active = resultsEl.querySelector('.is-active');
      if (active) { e.preventDefault(); window.location.href = active.href; }
    });
  }

  root.addEventListener('click', function (e) {
    var intent = e.target.closest('[data-vv-search-intent]');
    if (!intent) return;
    var q = intent.getAttribute('data-vv-search-intent');
    input.value = q;
    syncPlaceholder();
    lastQuery = q;
    search(q);
    input.focus();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
  }
})();
